var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('audio',{ref:"audioPlayer",staticStyle:{"width":"70%"},attrs:{"controls":"","src":_vm.AudioSrc},on:{"ended":_vm.overAudio,"pause":_vm.onPause,"play":_vm.onPlay,"loadeddata":_vm.loadeddata,"timeupdate":_vm.timeupdate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }